import { Box, Button } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { IShortMessageObject } from '@/types/gigiChat/Chat'
import { IConversation } from '@/types/gigiChat/Conversation'

const ExitPromptLibrary: React.FC<{
    isConnected: boolean
    item: IShortMessageObject | IConversation
    endPromptConversation: () => void
}> = ({ isConnected, item, endPromptConversation }) => {
    const { t } = useTranslation()

    if (isConnected) {
        return (
            <>
                <Button variant="outline" size="lg" onClick={endPromptConversation}>
                    {t('chat.promptLib.exitBtn', {
                        label: item.settings?.processingModePromptLibrary?.label,
                        interpolation: { escapeValue: false },
                    })}
                </Button>
            </>
        )
    }

    return (
        <Box fontSize={'xs'}>
            {t('chat.promptLib.ended', {
                label: item.settings?.processingModePromptLibrary?.label,
                interpolation: { escapeValue: false },
            })}
        </Box>
    )
}

export default ExitPromptLibrary
